export const PAGE_SIZE = 25;
export const DEBOUNCE_MS = 300;
export const STALE_TIME = 5 * 60 * 1000;
